/* eslint-disable import/prefer-default-export */
const pitchTypeGroups: Record<string, string> = {
    FF: 'FASTBALL',
    CU: 'BREAKING',
    CH: 'OFFSPEED',
}

export function getPitchTypeGroup(pitchType: string): string | null {
    const upperPitchType = String(pitchType || '').toUpperCase()
    return pitchTypeGroups[upperPitchType] || null
}
